<template>
	<div v-if="item" class="text-center w-[500px] max-w-[100%]">
		<div>
			<ul>
				<li
					v-for="row of listData"
					:key="row.code"
					class="flex w-full justify-between py-3 border-b border-gray-300 last:border-b-0">
					<span class="font-semibold text-gray-700">{{ row.label }}</span>
					<span class="text-gray-600">{{ row.value }}</span>
				</li>
			</ul>
		</div>

		<img v-if="item.picture" :src="item.picture" alt="Base64 Image" />
	</div>
</template>

<script lang="ts" setup>
	import { computed, ref } from 'vue'
	import type { Item } from '@/data/schema/item'

	const props = withDefaults(
		defineProps<{
			item: Item | undefined
		}>(),
		{
			item: undefined
		}
	)

	const item = ref(props.item)

	const listData = computed(() => {
		if (item.value) {
			const list = [
				{ label: 'PRODUCT CODE', value: item.value.code, code: 'code' },
				{ label: 'PRODUCT NAME', value: item.value.name, code: 'name' },
				{
					label: 'WEIGHT',
					value: (item.value.weight * 1000).toFixed(2) + 'kg',
					code: 'weight'
				}
			]

			if (item.value.item_no) {
				list.unshift({
					label: 'UNIQUE ITEM NO',
					value: item.value.item_no,
					code: 'item_no'
				})
			}

			return list
		} else {
			return []
		}
	})
</script>
